'use client';

import { createContext, useContext } from 'react';
import type { SessionUser } from './session-user';

export type SessionUserState = {
  user: SessionUser | null;
  /** Always false: the user comes from the server render. Kept for callers. */
  loading: boolean;
};

const SessionUserContext = createContext<SessionUser | null>(null);

/**
 * The storefront layout provides the user it already resolved on the server.
 * Every change of session re-renders that layout — sign-in ends with
 * router.refresh(), sign-out and OAuth with a full navigation — so there is no
 * browser-side session to subscribe to, and no supabase-js on every page.
 */
export function SessionUserProvider({
  user,
  children,
}: {
  user: SessionUser | null;
  children: React.ReactNode;
}) {
  return (
    <SessionUserContext.Provider value={user}>
      {children}
    </SessionUserContext.Provider>
  );
}

export function useSessionUser(): SessionUserState {
  return { user: useContext(SessionUserContext), loading: false };
}
